<template>
  <form class="auth-form" @submit.prevent="handleSubmit">
    <div class="auth-form__head">
      <div class="auth-form__badge">Регистрация</div>
      <h2>{{ title }}</h2>
      <p>{{ subtitle }}</p>
    </div>

    <!--<div class="register-steps" aria-label="Этапы регистрации">
      <div
        v-for="item in steps"
        :key="item.value"
        class="register-step"
        :class="{ active: step === item.value, done: step > item.value }"
      >
        <span>{{ item.value }}</span>
        <strong>{{ item.label }}</strong>
      </div>
    </div>-->

    <div v-if="step === 1" class="stack-md">
      <BaseInput v-model="model.full_name" label="Имя и фамилия" placeholder="Иван Иванов" required autocomplete="name" />
      <BaseInput v-model="model.email" type="email" label="Email" placeholder="you@example.com" required autocomplete="email" />
      <BaseInput v-model="model.password" type="password" label="Пароль" placeholder="Минимум 6 символов" required autocomplete="new-password" />
      <BaseInput v-model="model.password_repeat" type="password" label="Повтор пароля" placeholder="Повтори пароль" required autocomplete="new-password" />
    </div>

    <div v-else-if="step === 2" class="stack-md">
      <BaseInput
        :model-value="model.phone"
        type="tel"
        label="Телефон"
        placeholder="+7 917 131 57 89"
        required
        autocomplete="tel"
        inputmode="tel"
        maxlength="16"
        @update:modelValue="updatePhone"
      />

      <div class="verification-block">
        <!--<div class="verification-block__head">
          <strong>Способ подтверждения</strong>
          <span>Без SMS</span>
        </div>-->

        <div class="verification-methods">
          <button
            v-for="item in methodOptions"
            :key="item.value"
            type="button"
            class="verification-method"
            :class="{ active: selectedMethod === item.value }"
            @click="setMethod(item.value)"
          >
            <span class="verification-method__icon" aria-hidden="true" v-html="item.icon"/>
            <span class="verification-method__content">
              <strong>{{ item.label }}</strong>
              <small>{{ item.description }}</small>
            </span>
          </button>
        </div>
      </div>

      <p class="auth-note">{{ methodNote }}</p>
    </div>

    <div v-else class="stack-md">
      <div class="otp-field">
        <span class="otp-field__label">{{ codeLabel }}</span>
        <PhoneCodeCells
          :model-value="model.code"
          :length="4"
          @update:modelValue="updateCode"
        />
      </div>
      <p class="auth-note">
        {{ codeNote }} <strong>{{ prettyPhone }}</strong>.
      </p>
    </div>

    <label v-if="step === 1" class="consent-row">
      <input v-model="model.consent" type="checkbox" />
      <span>
        Я принимаю
        <router-link to="/privacy-policy" class="consent-link">политику конфиденциальности</router-link>
        и
        <router-link to="/personal-data-consent" class="consent-link">согласие на обработку данных</router-link>.
      </span>
    </label>

    <p v-if="error" class="message message--error">{{ error }}</p>
    <p v-if="success" class="message message--success">{{ success }}</p>

    <div class="auth-submit" :class="{ 'auth-submit--grid': step > 1 }">
      <BaseButton v-if="step > 1" block variant="ghost" :disabled="loading" type="button" @click="$emit('back')">Назад</BaseButton>
      <BaseButton block :loading="loading" type="submit">{{ submitText }}</BaseButton>
    </div>

    <button v-if="step === 3" type="button" class="resend-link" :disabled="loading" @click="$emit('resend-code')">
      Запросить ещё раз
    </button>
  </form>
</template>

<script>
import BaseButton from '../ui/BaseButton.vue';
import BaseInput from '../ui/BaseInput.vue';
import PhoneCodeCells from './PhoneCodeCells.vue';
import { formatRuPhone } from '../../utils/ruPhone';

export default {
  name: 'RegisterForm',
  components: { BaseButton, BaseInput, PhoneCodeCells },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    step: {
      type: Number,
      default: 1,
    },
    loading: Boolean,
    error: String,
    success: String,
    clubs: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'start', 'send-code', 'confirm-code', 'resend-code', 'back'],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    steps() {
      return [
        { value: 1, label: 'Данные' },
        { value: 2, label: 'Телефон' },
        { value: 3, label: 'Код' },
      ];
    },
    methodOptions() {
      return [
        {
          value: 'call',
          label: 'По номеру',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE --><path fill="#c589ff" d="M19.95 21q-3.125 0-6.175-1.362t-5.55-3.863t-3.862-5.55T3 4.05q0-.45.3-.75t.75-.3H8.1q.35 0 .625.238t.325.562l.65 3.5q.05.4-.025.675T9.4 8.45L6.975 10.9q.5.925 1.187 1.787t1.513 1.663q.775.775 1.625 1.438T13.1 17l2.35-2.35q.225-.225.588-.337t.712-.063l3.45.7q.35.1.575.363T21 15.9v4.05q0 .45-.3.75t-.75.3M13 11V5h2v2.6l5-5L21.4 4l-5 5H19v2z"/></svg>',
          description: 'Поступит звонок, нужно ввести последние 4 цифры номера.',
        },
        {
          value: 'telegram',
          label: 'Telegram',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14"><!-- Icon from Streamline color by Streamline - https://creativecommons.org/licenses/by/4.0/ --><g fill="none" fill-rule="evenodd" clip-rule="evenodd"><path fill="#00000000" d="M7 .25a6.75 6.75 0 1 0 0 13.5A6.75 6.75 0 0 0 7 .25"/><path fill="#c589ff" d="m10.297 3.132l-1.045 7.932l-1.949-1.561l-1.685 1.604V8.38l2.228-1.722a.5.5 0 1 0-.611-.792L4.549 7.943l-2.417-.876z"/></g></svg>',
          description: 'Код придёт в Telegram, если номер привязан к аккаунту.',
        },
      ];
    },
    selectedMethod() {
      return ['call', 'telegram'].includes(this.model.verification_method)
        ? this.model.verification_method
        : 'call';
    },
    title() {
      if (this.step === 2) return 'Подтвердите телефон';
      if (this.step === 3) return 'Введи код';
      return 'Создай новый аккаунт';
    },
    subtitle() {
      if (this.step === 2) return 'Выбери Телефонный звонок или Telegram.';
      if (this.step === 3) {
        return this.selectedMethod === 'telegram'
          ? 'Остался последний шаг — введите код из Telegram.'
          : 'Остался последний шаг — введите последние 4 цифры телефона, с которого поступил звонок';
      }
      return 'Укажи данные аккаунта и продолжи регистрацию.';
    },
    submitText() {
      if (this.step === 2) {
        return this.selectedMethod === 'telegram' ? 'Получить код в Telegram' : 'Заказать звонок';
      }

      if (this.step === 3) return 'Подтвердить регистрацию';
      return 'Продолжить';
    },
    methodNote() {
      if (this.selectedMethod === 'telegram') {
        return 'На следующем шаге нужно будет ввести код, который придёт в Telegram.';
      }

      return 'На следующем шаге нужно будет ввести последние 4 цифры телефона, с которого поступил звонок.';
    },
    codeLabel() {
      return this.selectedMethod === 'telegram' ? 'Код из Telegram' : '4 последние цифры телефона';
    },
    codeNote() {
      return this.selectedMethod === 'telegram'
        ? 'Введи код, который пришёл в Telegram на номер'
        : 'Введи последние 4 цифры номера входящего звонка на';
    },
    prettyPhone() {
      return this.model.phone || 'указанный телефон';
    },
  },
  created() {
    if (!['call', 'telegram'].includes(this.model.verification_method)) {
      this.setMethod('call');
    }
  },
  methods: {
    setMethod(method) {
      if (!['call', 'telegram'].includes(method)) return;

      this.$emit('update:modelValue', {
        ...this.modelValue,
        verification_method: method,
        method,
      });
    },
    updatePhone(value) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        phone: formatRuPhone(value),
      });
    },
    updateCode(value) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        code: String(value || '').replace(/\D/g, '').slice(0, 4),
      });
    },
    handleSubmit() {
      if (this.step === 2) {
        this.$emit('send-code');
        return;
      }

      if (this.step === 3) {
        this.$emit('confirm-code');
        return;
      }

      this.$emit('start');
    },
  },
};
</script>

<style scoped>
.auth-form__head {
  margin-bottom: 24px;
}

.auth-form__badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  background: rgba(143, 107, 255, 0.16);
  color: #b8a8ff;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

h2 {
  margin: 16px 0 8px;
  font-size: clamp(28px, 4vw, 36px);
}

p {
  margin: 0;
  color: var(--text-soft);
  line-height: 1.65;
}

.register-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 22px;
}

.register-step {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 8px 10px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.07);
  color: var(--text-faded);
}

.register-step span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  font-size: 12px;
  font-weight: 900;
}

.register-step strong {
  font-size: 13px;
}

.register-step.active,
.register-step.done {
  color: var(--text);
  border-color: rgba(143, 107, 255, 0.28);
  background: rgba(143, 107, 255, 0.11);
}

.verification-block {
  padding: 14px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.07);
  margin-bottom: 18px;
}

.verification-block__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.verification-block__head strong {
  color: var(--text);
  font-size: 14px;
}

.verification-block__head span {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(255, 67, 47, 0.14);
  color: var(--accent);
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
}

.verification-methods {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.verification-method {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-height: 92px;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-soft);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.verification-method:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.06);
}

.verification-method.active {
  border-color: rgba(143, 107, 255, 0.52);
  background: rgba(143, 107, 255, 0.14);
  color: var(--text);
}

.verification-method__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  color: var(--text);
  font-size: 18px;
  font-weight: 900;
}

.verification-method__content {
  display: grid;
  gap: 5px;
}

.verification-method__content strong {
  color: inherit;
  font-size: 14px;
}

.verification-method__content small {
  color: var(--text-faded);
  line-height: 1.4;
}

.otp-field {
  display: grid;
  gap: 10px;
}

.otp-field__label {
  display: block;
  font-weight: 700;
  color: var(--text);
}

.auth-note {
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  font-size: 14px;
  margin-top: 18px;
}

.auth-note strong {
  color: var(--text);
}

.consent-row {
  margin-top: 18px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: var(--text-soft);
  line-height: 1.6;
}

.consent-row input {
  margin-top: 4px;
  accent-color: var(--accent);
}

.consent-link {
  color: var(--text);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.message {
  margin: 16px 0 0;
  padding: 14px 16px;
  border-radius: 16px;
}

.message--error {
  background: rgba(255, 90, 103, 0.12);
  color: #ffb2b8;
  border: 1px solid rgba(255, 90, 103, 0.18);
}

.message--success {
  background: rgba(51, 209, 122, 0.12);
  color: #98f0bb;
  border: 1px solid rgba(51, 209, 122, 0.18);
}

.auth-submit {
  margin-top: 24px;
}

.auth-submit--grid {
  display: grid;
  grid-template-columns: 0.7fr 1fr;
  gap: 12px;
}

.resend-link {
  margin-top: 16px;
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--text-soft);
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.resend-link:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 560px) {
  .register-steps {
    gap: 6px;
  }

  .register-step {
    flex-direction: column;
    align-items: flex-start;
    min-height: 64px;
  }

  .verification-methods {
    grid-template-columns: 1fr;
  }

  .auth-submit--grid {
    grid-template-columns: 1fr;
  }
}
</style>